var _polygon, _polygon2, _rect, _rect2, _rect3, _g, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureMoulding2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "256px",
    height: "302px",
    viewBox: "0 0 256 302",
    enableBackground: "new 0 0 256 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.3508,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 23.3,27.5 23.3,21.2 2.7,21.2 8.4,27.5 23.2,27.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.3508,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 232.2,27.7 247,27.7 252.7,21.3 232.1,21.3 232.1,27.7 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 143.6,
    y: 60.8,
    fill: "#494848",
    width: 0,
    height: 40.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0079,
    strokeMiterlimit: 10,
    d: "M23.2,188.5c0,0,0,2.6-0.4,3.7 c-0.7,1.8,0.5,2.3,0.5,2.3H128c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H23.2L23.2,188.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0079,
    strokeMiterlimit: 10,
    d: "M23.2,183.2c0,0,0.1,1.9-0.4,3.7 c-1.1,2.3,0.5,2.3,0.5,2.3H128c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H23.2L23.2,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0079,
    strokeMiterlimit: 10,
    d: "M25.9,10.6h102.3l-0.3,163.3 c0,0,0.1,1.1,0,4.3c0.5,1.9,1,5.3-0.5,5.3c-1.6,0-99.2,0-103.4,0c-2.9,0-0.9-2.9-1.2-8.8c0-1.4,0-164.1,0-164.1L25.9,10.6 L25.9,10.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M129.9,218.5c0,0,0,2.6-0.4,3.7c-0.7,1.8,0.5,2.3,0.5,2.3h103 c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H129.9L129.9,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M129.9,213.2c0,0,0.1,1.9-0.4,3.7c-1.1,2.3,0.5,2.3,0.5,2.3h103 c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H129.9L129.9,213.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M132.5,10.6h100.7l-0.3,193.3c0,0,0.1,1.1,0,4.3 c0.5,1.9,1,5.3-0.5,5.3c-1.6,0-97.7,0-101.8,0c-2.9,0-0.9-2.9-1.2-8.8c0-1.4,0-194.1,0-194.1L132.5,10.6L132.5,10.6z"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.7,
    y: 0,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.3642,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 249.9,
    height: 21.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureMoulding2);
export default __webpack_public_path__ + "static/media/feature-moulding2.41ddd92148dbcba114ab090efbc85e5c.svg";
export { ForwardRef as ReactComponent };